import React from 'react'
import { CircularProgress, TextField } from '@mui/material'
import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormTextInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
}

const EntityFormTextInput = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
}: EntityFormTextInputProps) => (
  <TextField
    key={`field-${field.id.toString()}`}
    required={field.required}
    label={field.name}
    value={fieldValue?.value ?? ''}
    onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
    error={error}
    disabled={disabled || loading}
    placeholder={loading ? ' ' : undefined}
    InputLabelProps={loading ? { shrink: true } : undefined}
    InputProps={{
      endAdornment: loading ? <CircularProgress size={20} /> : undefined,
    }}
  />
)

export default EntityFormTextInput
